<template>
   <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center" v-for="(item, index) in customerList" :key="index">
            <vx-card>
              <vs-row vs-type="flex" vs-align="center">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="4">
                  <!-- {{item}} -->
                  <img v-if="item.picture"
                  :src="item.picture"
                  alt="login"
                  style="width:80px;height:80px;object-fit:contain;border:1px solid #ccc;padding:5px;
                  border-radius: 10%;"
                  class="mx-auto">
                  <img v-else :src="default_image">
                </vs-col>
                <vs-col  vs-justify="left" type="flex" vs-align="left" vs-lg="6" vs-sm="4" vs-xs="4">
                  <h2> {{ item.brand_company_name || "Demo" }}</h2>
                </vs-col>
                <!-- <pre>{{item}}</pre> -->
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="4">
                  <button class="launch_button" @click="GetRoleDetail(item.customer_id, item.brand_company_name,item.localization_setting )">Launch</button>
                </vs-col>
              </vs-row>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { GetCountryList } from '@/api/common'

import { fetchCustomerList, GetRoleDetail ,setTimezone} from '@/api/customer'
import { fetch_accessible_module_list } from '@/api/login'
// import { new_fetch_accessible_module_list } from '@/api/login'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      customerList: [],
      default_image:''
    }
  },
  created () {

    this.default_image = process.env.VUE_APP_WORKSPACE_DEFAULT_IMAGE
  },
  methods: {
    ...mapActions(['SET_NAVMENU_ITEM', 'SET_USER_INFO', 'SET_ROLE_PERMISSION', 'SET_LOCALIZATION', 'SET_COUNTRY_LIST']),
    fetchCustomerList () {
      // if(this.$store.getters.customerId === '' || this.$store.getters.customerId === null) {
      //   this.$router.push('/pages/login').catch(() => {})
      // } else {
      this.$vs.loading()
      fetchCustomerList()
        .then((response) => {
          this.customerList.push(...response.data.data.list)
          this.$vs.loading.close()
        })
        .catch((apiError) => {

        })
      // }
    },
    /* lunchCustomerWorkspace (customerId, customerName) {
      this.GetRoleDetail(customerId, customerName)
    }, */
    async GetRoleDetail (customerId, customerName, localizationSetting) {

      try {
        this.$vs.loading({
          text:`We are Redirecting to ${customerName}`
        })
        const data = await GetRoleDetail(customerId, customerName)
        const payload ={
          platform_customer_id: localStorage.getItem('customer_id'),
          timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        const result = await setTimezone(payload)
        this.$store.dispatch('setCustomerId', customerId)
        this.$store.dispatch('setCustomerName', customerName)
        if (data.data.data.list.admin_portal_access === 1) {
          localStorage.setItem('can_delete', data.data.data.list.can_delete)
          localStorage.setItem(
            'role_permission',
            data.data.data.list.role_permission
          )
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          userInfo.picture = data.data.data.list.picture
          userInfo.role_name = data.data.data.list.role_name
          localStorage.setItem('userInfo', JSON.stringify(userInfo))

          //setting localization
          localStorage.setItem('localization', JSON.stringify(localizationSetting))

          this.SET_LOCALIZATION(localizationSetting)

          this.$vs.theme({
            primary: localizationSetting.primary_color,
            secondary: localizationSetting.secondary_color,
            heading: localizationSetting.heading_color,
            text: localizationSetting.text_color
          })

          //setting localization


          this.SET_ROLE_PERMISSION(data.data.data.list.role_permission)
          this.SET_USER_INFO(userInfo)

          //
          if (data.data.data.list.role_permission === 0) {
            this.fetch_accessible_module_list()
          } else {
            //this.$router.push('/dashboard/analytics').catch(() => {})
            this.$router.push('/admin/dashboard').catch(() => {})
          }


          // this.$router.push('/dashboard/analytics').catch(() => {})
        } else {
          this.$vs.loading.close()
          localStorage.removeItem('access_token')
          localStorage.removeItem('userInfo')
          this.$vs.notify({
            title: 'Warning',
            text: 'Sorry! you don\'t have permission to login here',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          this.$router.push('/pages/login').catch(() => {})
        }

      } catch (e) {
        console.warn(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    //For Permission Checking
    async fetch_accessible_module_list () {

      //parent module for education
      try {
        const responseModuleList = await fetch_accessible_module_list(
          localStorage.getItem('customer_id')
        )

        /* localStorage.setItem('userInfo.picture', 'https://scoolio-files.s3.ap-south-1.amazonaws.com/20210120073918151515/Default/9AZkBpOTyMkn2rhM.png') */
        if (responseModuleList) {
          this.SET_NAVMENU_ITEM(responseModuleList.data.data.list)

          //this.$router.push('/dashboard/analytics').catch(() => {})
          this.$router.push('/teacher/dashboard').catch(() => {})
        }
      } catch (error) {
        //
      }
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.SET_COUNTRY_LIST(data.data.countries_list)
      } catch (e) {}
    },

    //For Permission Checking
  },
  mounted () {
    this.fetchCustomerList()
    this.fetchCountry()

  }
}
</script>
<style scoped>
.launch_button {
  border: 1px solid rgba(var(--vs-primary), 1) !important;
  background: transparent !important;
  color: rgba(var(--vs-primary), 1) !important;
  border-radius: 6px;
  padding: .75rem 2rem;
  cursor: pointer;
}
</style>
